"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigIntStringSchema = void 0;
const zod_1 = require("zod");
exports.BigIntStringSchema = zod_1.z
    .string()
    .regex(/^\d+$/, 'Value must be a string representing a non-negative integer')
    .refine((value) => {
    try {
        BigInt(value); // Try to convert to BigInt
        return true; // If there is not an error, it is a BigInt
    }
    catch {
        return false; // If there is an error, it is not a BigInt
    }
}, {
    message: 'Value must be a valid BigInt-compatible string',
});
